import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { OverviewComponent } from '../add-project-module/brief-sections/overview/overview.component';
import { ChangeComponent } from '../add-project-module/change/change.component';
import { ContractorComponent } from '../add-project-module/contractor/contractor.component';
import { ContractsComponent } from '../add-project-module/contracts/contracts.component';
import { InsuranceComponent } from '../add-project-module/insurance/insurance.component';
import { PaymentComponent } from '../add-project-module/payment/payment.component';
import { ScopeWorkComponent } from '../add-project-module/scope-work/scope-work.component';
import { SubContractorComponent } from '../add-project-module/sub-contractor/sub-contractor.component';
import { SuppliarsComponent } from '../add-project-module/suppliars/suppliars.component';
@Component({
  selector: 'app-add-project',
  standalone: true,
  imports: [
    MatTabsModule,
    OverviewComponent,
    ChangeComponent,
    ContractorComponent,
    ContractsComponent,
    InsuranceComponent,
    PaymentComponent,
    ScopeWorkComponent,
    SubContractorComponent,
    SuppliarsComponent,
  ],

  templateUrl: './add-project.component.html',
  styleUrls: ['./add-project.component.css'],
})
export class AddProjectComponent {
  selectedTabIndex = 0;


  onTabChange(index: number) {
    this.selectedTabIndex = index;
  }
}
